import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useSystemInformation } from '../../hooks/useSystemInformation';
import { useFeature } from '../../hooks/useFeature';

import { Label as CmpLabel } from "../../components/Label/index.js";

export function SystemInformationPanel() {
  const navigate = useNavigate();
  const { hasFeature } = useFeature();

  const { systemInfoPanelVisible, usePanelWrapper, usePanelIcon, panelContent } = useSystemInformation();
  const usiTmp = useSystemInformation();

  const render = function() {
    if (systemInfoPanelVisible && panelContent)
      return (
        <div className='mb-10'>
          {!usePanelWrapper && (
            <>
              {panelContent}
            </>
          )}
          {!!usePanelWrapper && (
            <CmpLabel type={CmpLabel.types.error} useIcon={usePanelIcon}>
              {panelContent}
            </CmpLabel>
          )}
        </div>
      );
      return null;
  }

  return render();
}